import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';
import type { ICategoryTogglesProps, SceneCategory } from '@/@types/ai-studio';
import { SCENE_CATEGORIES, getSceneCategoryLabel } from '@/@types/ai-studio';

export function CategoryToggles({
  enabledCategories,
  onCategoriesChange,
  disabled = false,
}: ICategoryTogglesProps) {
  const handleToggle = (category: SceneCategory) => {
    if (enabledCategories.includes(category)) {
      // Don't allow disabling all categories
      if (enabledCategories.length > 1) {
        onCategoriesChange(enabledCategories.filter((c) => c !== category));
      }
    } else {
      onCategoriesChange([...enabledCategories, category]);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">Scene Categories</span>
        <span className="text-xs text-muted-foreground">
          {enabledCategories.length}/{SCENE_CATEGORIES.length} enabled
        </span>
      </div>
      <div className="flex flex-col gap-2">
        {SCENE_CATEGORIES.map((category) => {
          const isEnabled = enabledCategories.includes(category);
          const isLastEnabled = isEnabled && enabledCategories.length === 1;

          return (
            <label
              key={category}
              className={cn(
                'flex items-center gap-3 rounded-md px-3 py-2 transition-colors',
                disabled || isLastEnabled
                  ? 'cursor-not-allowed opacity-50'
                  : 'cursor-pointer hover:bg-muted/50'
              )}
            >
              <Checkbox
                checked={isEnabled}
                onCheckedChange={() => handleToggle(category)}
                disabled={disabled || isLastEnabled}
              />
              <span className="text-sm text-foreground">{getSceneCategoryLabel(category)}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
